<section class="content-wrapper">
	<aside class="sidebar-container"><ng-content select=".sidebar"></ng-content></aside>
	<section class="content-container"><ng-content select=".content"></ng-content></section>
</section>
